import { createAppKit, useAppKitAccount } from '@reown/appkit/react'
import { WagmiProvider } from 'wagmi'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Connected } from './components/Connected'
import { projectId, metadata, networks, wagmiAdapter } from './config'

import "./App.css"

const queryClient = new QueryClient()

const generalConfig = {
  projectId,
  networks,
  metadata,
  themeMode: 'light' as const,
  themeVariables: {
    '--w3m-accent': '#0052ff',
  }
}

// Create modal
createAppKit({
  adapters: [wagmiAdapter],
  ...generalConfig,
  features: {
    analytics: true // Optional - defaults to your Cloud configuration
  }
})

export function App() {
  const { isConnected } = useAppKitAccount() // AppKit hook to get the address and check if the user is connected
  return (
       <div className={"main"}>
        <h1 className={"title"}>  
          <p>SHIB<span className="red-text">Pupz</span></p>
          <p><span className="black-text">are for</span></p>
          <p><img src="/everyone.png" alt="everyone" style={{ width: '150px' }} /></p>
        </h1>
        <p><img src="/sample.gif" alt="Logo" style={{ width: '300px', height: '300px' }} /></p>
        {!isConnected &&
        <div>
          <div className={"grid"}>
            <div className={"card2"}>
            <span className="red-text">Option 1: </span>
              Connect your wallet to open the Minting dApp.
          </div>
        </div>
      </div>}
        <WagmiProvider config={wagmiAdapter.wagmiConfig}>
          <QueryClientProvider client={queryClient}>
            <appkit-button/>
            {!isConnected &&
              <div>
                <br></br>
                <div className={"grid"}>
                  <div className={"card2"}>
                  <p><span className="red-text">Option 2: </span> Use our self-minting contract.</p>
                  <br></br>
                  <p>Send $55 worth of ETH on Base directly from your self-custody wallet to: </p>
                  <b><p>shibpupz.eth</p>
                  <br></br>
                  <p>(add $1 - $2 tolerance - unused ETH will be refunded automatically).</p></b>
                </div>
              </div>
            </div>}
            <Connected/>
          </QueryClientProvider>
        </WagmiProvider>
      </div>
  )
}

export default App
